import {FC, PropsWithChildren, useEffect, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import 'file-power-boundle'
import {useUserInfoContext} from '@/store/userInfo'
import {getLocalstorage, getLocalstorageWithsk, sendLoginLogOnce } from "@/utils/utils";
import {fxsLocalStorageKey, localStorageKey, sdgjjxsLocalStorageKey, zmdfxsLocalStorageKey} from '@/config/config'

type PropType = FC<PropsWithChildren<{}>>

const thiteList = ['/login']
const RouterEnter: PropType = ({children}) => {
    const [done, setDone] = useState(false)
    const {updateShopCarCount, updateBaseInfo,updateZmdddCount} = useUserInfoContext()
    const navigator = useNavigate()
    const location = useLocation()
    const {userInfo} = useUserInfoContext()

    useEffect(() => {
        if (userInfo) {
            // 更新购物车
            updateShopCarCount()
            updateZmdddCount()
            sendLoginLogOnce(userInfo.dlm, userInfo.zhmc)
            // if(userInfo.lx==='ZMJFXS' || userInfo.lx==='FZMJFXS'){
            //     updateFxsBaseInfo()
            // }else {
            // }
            updateBaseInfo()
            // 更新用户基本信息

        }
        if (thiteList.includes(location.pathname) || userInfo) {
            setDone(true)
        } else {
            // const sdgjval = getLocalstorageWithsk(sdgjjxsLocalStorageKey, 'userinfo');
            // if (sdgjval) {
            //     window.location.replace(window.location.origin + '/sdgjjxs/')
            //     return;
            // }
            const fxsval = getLocalstorageWithsk(fxsLocalStorageKey, 'userinfo');
            if (fxsval) {
                window.location.replace(window.location.origin + '/yxfxs/')
                return;
            }
            const zmdfxsval =getLocalstorageWithsk(zmdfxsLocalStorageKey, 'userinfo');
            if (zmdfxsval) {
                window.location.replace(window.location.origin + '/zmdfxs/')
                return;
            }
            // 前往登录
            navigator('/login?f=' + location.pathname, {
                replace: true
            })
        }
    }, [navigator, location.pathname, updateShopCarCount, updateBaseInfo])

    useEffect(() => {
        window.scrollTo(0,0)
      }, [location.pathname])

    return done && children
}

export default RouterEnter
